/**
 * AppRoot.js
 *
 *
 */
// Needed for redux-saga es6 generator support
import '@babel/polyfill';
import React from 'react';

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import FontFaceObserver from 'fontfaceobserver';
import 'sanitize.css/sanitize.css';
// Import root app
import App from 'containers/App';
// Import Language Provider
import LanguageProvider from 'containers/LanguageProvider';
// Setup apollo
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';
import MercuryContext, { MercuryConnection } from 'ConnectionManager/mercuryContext';

import configureStore, { history } from '../../../app/configureStore';

// Observe loading of Adelle Sans (to remove adelle sans, remove the <script> tag in
// the index.html file and this observer)
const openSansObserver = new FontFaceObserver('Open Sans');
const materialIconsObserver = new FontFaceObserver('Material Icons');

// When Adelle Sans is loaded, add a font-family using Adelle Sans to the body
Promise.all([openSansObserver.load(), materialIconsObserver.load()]).then(() => {
  document.body.classList.add('fontLoaded');
}, () => {
  document.body.classList.remove('fontLoaded');
});

// Create redux store with history
const store = configureStore();

const AppRoot = (messages) => (
  <Provider store={store}>
    <MercuryContext.Provider value={new MercuryConnection()}>
      <MercuryContext.Consumer>
        {({ apolloClient }) => (
          <LanguageProvider messages={messages}>
            <ConnectedRouter history={history}>
              <ApolloProvider client={apolloClient}>
                <ApolloHooksProvider client={apolloClient}>
                  <App />
                </ApolloHooksProvider>
              </ApolloProvider>
            </ConnectedRouter>
          </LanguageProvider>
        )}
      </MercuryContext.Consumer>
    </MercuryContext.Provider>
  </Provider>
);

export default AppRoot;
